<template>
  <List
    title="applications"
    resource="applications"
    :basePath="basePath"
    :fields="fields"
    ref="list"
    track-by="code"
    on-row-click="details"
    data-provider="$raaDataProvider"
    :initial-filter="entityDefaultFilter"
    :filter-classes="{container: 'w-2/3 items-end mb-6', quickFilters: 'w-1/2 mr-6', searchContainer: 'flex-1'}"
    :pageSize="20"
    infinity-scroll
  >
    <template v-slot:quickfilter="{applyFilter}">
      <div class="form-col">
        <label>{{entityFilterName}}</label>
        <Dropdown
          :options="entityFilterOptions"
          :value="entityFilterValue"
          @input="v => { applyFilter(mapEntityFilterToQuery(v)); }"
          show-all
          no-clear
        />
      </div>
    </template>
    <template v-slot:inline-actions="actionsScope">
      <button
        class="btn-action-warning focus:outline-none"
        type="button"
        v-if="!actionsScope.record.deletedAt"
        @click.stop="deleteApp(actionsScope.record)"
      >
        <icon class="w-5 h-5 mr-1" name="trash"/>
      </button>
    </template>
  </List>
</template>

<script>
  import List from "@/components/auth/list/List";
  import DateTimeField from "@/components/auth/list/fields/DateTimeField";
  import ModalNavigation from "@/mixins/ModalNavigation";
  import ConfirmationMixin from "@/mixins/ConfirmationMixin";
  import NotifyMixin from "@/mixins/NotifyMixin";
  import Icon from "@/components/ui/Icon";
  import Dropdown from "@/components/ui/Dropdown";
  import EntityFilterMixin from "@/components/auth/EntityFilterMixin";

  export default {
    name: "ApplicationsList",
    components: {
      List,
      Dropdown,
      Icon
    },
    mixins: [ModalNavigation, ConfirmationMixin, NotifyMixin, EntityFilterMixin],
    computed: {
      basePath: function () {
        return this.$route.path;
      },
    },
    data() {
      return {
        fields: [
          {
            name: 'name',
            title: 'name',
            sortField: 'name',
          },
          {
            name: 'apiEndpoint',
            title: 'api endpoint',
            sortField: 'apiEndpoint',
          },
          {
            name: DateTimeField,
            sortField: 'createdAt',
            title: 'registered',
            switch: {
              source: 'createdAt'
            },
            titleClass: 'text-center',
            dataClass: 'text-center',
          },
          {
            name: 'inline-actions',
            title: '',
            width: "10%",
          }
        ],
      }
    },
    methods: {
      deleteApp(app) {
        this.requestConfirmation({
          confirmationMessage: 'Are you sure you want to delete this application?',
          confirmBtnText: 'yes',
          cancelBtnText: 'no',
          confirmationType: 'warning'
        })
        .then(confirmed => confirmed
          ? this.$raaDataProvider.delete('applications', {id: app.code})
            .then(() => {
              this.$refs.list.doSearch();
              this.notifySuccess('application deleted');
            })
            .catch(error => this.notifyError(error.message))
          : null
        );
      }
    },
  }
</script>

<style scoped>

</style>
